import { MutationTuple, useMutation } from '@apollo/client';

import {
  DisconnectTicketingTokenMutation,
  DisconnectTicketingTokenMutationVariables,
  DISCONNECT_TICKETING_TOKEN,
  GET_TICKETING_CONNECTIONS,
} from '../graphql';

type UseDisconnectTicketingToken = MutationTuple<
  DisconnectTicketingTokenMutation,
  DisconnectTicketingTokenMutationVariables
>;

/**
 * Removes a ticketing connection. The connections query is refetched rather than the cache patched,
 * because a disconnect can change more than the row that went away: whether a company holds an
 * active GitHub App connection is what decides whether its Merge one reads as superseded.
 */
export const useDisconnectTicketingToken = (companyId: string): UseDisconnectTicketingToken =>
  useMutation<DisconnectTicketingTokenMutation, DisconnectTicketingTokenMutationVariables>(DISCONNECT_TICKETING_TOKEN, {
    refetchQueries: [{ query: GET_TICKETING_CONNECTIONS, variables: { companyId } }],
    awaitRefetchQueries: true,
  });
